import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GenericNotification } from './GenericNotification';

export const itemRenamedNotification = ({ name }) => {
  const ItemRenamedNotification = ({ notification }) => (
    <GenericNotification
      notification={notification}
      text={<FormattedMessage id="files-manager.item-renamed-notification" values={{ fileName: name }} />}
    />
  );

  return ItemRenamedNotification;
};
